module.exports = __webpack_public_path__ + "img/5a3dfa5.jpg";